import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import confirmationPageActions from '../actions/confirmationPage';
import informationPageActions from '../actions/informationPage';

function updateOnboardingStatus(store) {
    request.post(`/${config.url_prefix}/api/updateOnboardingStatus`)
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(confirmationPageActions.alertError('ipmob.internal.server.error'));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (!parsedResponse || response.statusCode >= 400 || response.code >= 400 || parsedResponse.statusCode >= 400 || parsedResponse.code >= 400) {
                        store.dispatch(confirmationPageActions.alertError('ipmob.error.process.request'));
                        store.dispatch(actions.enableLoadOverLay(false));
                    } else if(parsedResponse.pmEligibility && parsedResponse.pmEligibility.isEligible){
                        store.dispatch(actions.changeAppState('INTRODUCTION'));
                    } else if(parsedResponse.pmEligibility && !parsedResponse.pmEligibility.isEligible){
                        store.dispatch(informationPageActions.updateIneligibilityStatusCode(parsedResponse.pmEligibility.code));
                        store.dispatch(actions.changeAppState('INELIGIBLE'));
                    } else {
                        store.dispatch(confirmationPageActions.alertError('ipmob.error.process.request'));
                        store.dispatch(actions.enableLoadOverLay(false));
                    }
                } catch (exp) {
                    store.dispatch(confirmationPageActions.alertError('ipmob.error.process.request'));
                    store.dispatch(actions.enableLoadOverLay(false));
                }
            }
        });
}

export default updateOnboardingStatus;
